import DependentQuestions from "@/containers/survey/components/DependentQuestions";
import { useTranslation } from "react-i18next";
import DateFormatSelect from "../../DateFormatSelect";
import Field from "@/components/Field";
import Fieldset from "@/components/Fieldset";
import { isRequired } from "@/lib/form";
import { cfg } from "@/schemas/question/cfg";

interface QuestionDateHourProps {
  index: number;
}
const QuestionDateHour = ({ index }: QuestionDateHourProps) => {
  const { t } = useTranslation();

  return (
    <Fieldset>
      <Field
        name={`questions.${index}.cfg.type`}
        label={t("surveyEditor.dateHourType.format")}
        required={isRequired(cfg.shape.type)}
        render={({ field }) => <DateFormatSelect {...field} />}
      />
      <DependentQuestions index={index} />
    </Fieldset>
  );
};

export default QuestionDateHour;
